import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer" aria-label="91高清视频">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading tracking-wide">
                91高清视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              高清视频在线观看平台，提供超清画质高清影视在线体验。
              主打国产高清视频内容，每日更新热门影视资源，畅享流畅播放。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-category" className="hover:text-primary-400 transition-colors">视频分类</a>
            </h4>
            <ul className="space-y-2" id="footer-category">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2" id="footer-links">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">
                  全部视频
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer">
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-contact" className="hover:text-primary-400 transition-colors">联系方式</a>
            </h4>
            <div className="space-y-2 text-sm text-background-400" id="footer-contact">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                contact@91hdvideo.com
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                400-888-9999
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                北京市朝阳区建国路88号
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 91高清视频 版权所有 | 高清视频在线观看 | 超清视频在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#privacy" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#terms" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
              服务条款
            </a>
            <a href="#sitemap" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
              网站地图
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}